/**
 * React hook companion to `sectorTerminology.js`. Kept in a separate file so
 * the pure-function module can be unit tested without resolving the AuthContext
 * module alias under Jest.
 */
import { useAuth } from '@/contexts/AuthContext';
import { getSectorTerms } from '@/utils/sectorTerminology';

export const useSectorTerms = () => {
  const { user: currentUser } = useAuth();
  return getSectorTerms({
    business_type: currentUser?.business_type,
    appointment_category: currentUser?.appointment_category,
    appointment_subcategory: currentUser?.appointment_subcategory,
  });
};

// Re-exports so callers can write `from '@/utils/useSectorTerms'`
// or `from '@/utils/sectorTerminology'` interchangeably.
export { getSectorTerms, DEFAULT_TERMS, ALL_SECTOR_TERMS } from '@/utils/sectorTerminology';
